import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Button as ButtonPrimitive} from '@travel-frontend/ui-components';

export const Button = styled(ButtonPrimitive)(
  ({theme}) => css`
    padding: 12px 36px;
    font-size: 1.125rem;
    text-transform: uppercase;
    background-color: ${theme.colors.brandB};
    border-radius: 2px;
    letter-spacing: 1px;
  `
);
